import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class HouseWindow extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, w,h) {
    super(scene);

    this.workingWidth = w;
    this.workingHeight = h;
    this.bg = new Phaser.GameObjects.Rectangle(this.scene, 0,0,this.workingWidth, this.workingHeight, 0xffffff).setOrigin(0);
    this.add(this.bg);

    this.charContainer = new Phaser.GameObjects.Container(this.scene);
    this.add(this.charContainer);
    this.windowCharSprite = ABCyaPhaser.Images.addImage(0,56, UIAssetKeys._WindowGhost, this.charContainer).setOrigin(0);

    this.actionWaiter = Phaser.Math.Between(2000,20000) / 1000;
  }

  turnLightOn () {
    this.bg.fillColor = 0xfdfd77;
  }

  darkRoom () {
    this.bg.fillColor = 0x004271;
  }

  turnLightOff () {
    this.bg.fillColor = 0xffffff;
  }

  doGhostChar (time) {
    this.windowCharSprite.setFrame(UIAssetKeys._WindowGhost).setOrigin(0);
    this.windowCharSprite.x = Math.floor(this.workingWidth / 2) - Math.floor(this.windowCharSprite.width / 2);
    this.windowCharSprite.y = 36;
    ABCyaPhaser.Tweens.addTween(this.windowCharSprite, time - 200, { y: -36 }, Phaser.Math.Easing.Linear, () => this.turnLightOn());
    this.darkRoom();
  }

  doHeadChar (time) {
    this.windowCharSprite.setFrame(UIAssetKeys._WindowHead).setOrigin(0);
    this.windowCharSprite.x = Math.floor(this.workingWidth / 2) - Math.floor(this.windowCharSprite.width / 2);
    this.windowCharSprite.y = this.workingHeight;
    ABCyaPhaser.Tweens.addTween(this.windowCharSprite, time / 2, { y: this.workingHeight - this.windowCharSprite.height }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.windowCharSprite, time / 2, { y: this.workingHeight }, Phaser.Math.Easing.Linear);
    });
  }

  stopAnimations() {
    this.scene.tweens.killTweensOf(this.windowCharSprite);

    this.windowCharSprite.y = this.windowCharSprite.frame.name === UIAssetKeys._WindowHead ? this.workingHeight : -36;
  }

  tick (dt) {
    if (this.actionWaiter <= 0) {
      let time = Phaser.Math.Between(900,1600);
      const whichOne = Phaser.Math.Between(1,100);
      if (whichOne < 50) {
        this.doHeadChar(time);
      }
      else {
        time = Phaser.Math.Between(1200,1800);
        this.doGhostChar(time);
      }
      this.actionWaiter = (Phaser.Math.Between(6000,24000) + time) / 1000;
    }
    else {
      this.actionWaiter -= dt;
    }
  }
}